"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Management = void 0;
var Header_1 = require("./Header");
var Url_1 = require("./Url");
var axios_1 = require("axios");
var Enums_1 = require("./Enums");
var Management = /** @class */ (function () {
    function Management(managementKey, customDomain) {
        this.apikey = managementKey;
        this.customDomain = customDomain !== null && customDomain !== void 0 ? customDomain : { domainName: "api.decisionrules.io", protocol: Enums_1.Protocol.HTTPS, port: 443 };
        this.header = new Header_1.HeaderContext(new Header_1.ManagementHeader()).createHeader(this.apikey);
        this.urlBase = new Url_1.UrlContext(new Url_1.ManagementUrl).createUrl(undefined, this.customDomain);
    }
    /**
     * Returns rule by ruleId and version.
     *
     * @param ruleId
     * @param version
     *
     * @returns rule
     */
    Management.prototype.getRule = function (ruleId, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (version) {
                            url = "".concat(this.urlBase, "/rule/").concat(ruleId, "/").concat(version);
                        }
                        else {
                            url = "".concat(this.urlBase, "/rule/").concat(ruleId, "/");
                        }
                        return [4 /*yield*/, axios_1.default.get(url, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Returns all rules including Rule Flows present in space that belongs to management API key.
     *
     */
    Management.prototype.getSpaceItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.urlBase, "/space/items");
                        return [4 /*yield*/, axios_1.default.get(url, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Creates rule in space.
     *
     * @param rule
     */
    Management.prototype.createRule = function (rule) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.urlBase, "/rule/");
                        return [4 /*yield*/, axios_1.default.post(url, rule, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Updates rule that is in space.
     *
     * @param ruleId
     * @param rule
     * @param version
     */
    Management.prototype.updateRule = function (ruleId, rule, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.urlBase, "/rule/").concat(ruleId, "/").concat(version);
                        return [4 /*yield*/, axios_1.default.put(url, rule, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.status];
                }
            });
        });
    };
    /**
     * Deletes rule from space.
     *
     * @param ruleId
     * @param version
     */
    Management.prototype.deleteRule = function (ruleId, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.urlBase, "/rule/").concat(ruleId, "/").concat(version);
                        return [4 /*yield*/, axios_1.default.delete(url, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.status];
                }
            });
        });
    };
    /**
     * Returns RuleFlow by ruleId or version.
     *
     * @param ruleId
     * @param version
     */
    Management.prototype.getRuleFlow = function (ruleId, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (version) {
                            url = "".concat(this.urlBase, "/rule-flow/").concat(ruleId, "/").concat(version);
                        }
                        else {
                            url = "".concat(this.urlBase, "/rule-flow/").concat(ruleId, "/");
                        }
                        return [4 /*yield*/, axios_1.default.get(url, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Creates RuleFlow in space.
     *
     * @param ruleFlow
     */
    Management.prototype.createRuleFlow = function (ruleFlow) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.urlBase, "/rule-flow/");
                        return [4 /*yield*/, axios_1.default.post(url, ruleFlow, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Updates RuleFlow in space.
     *
     * @param ruleId
     * @param ruleFlow
     * @param version
     */
    Management.prototype.updateRuleFLow = function (ruleId, ruleFlow, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.urlBase, "/rule-flow/").concat(ruleId, "/").concat(version);
                        return [4 /*yield*/, axios_1.default.put(url, ruleFlow, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Deletes RuleFlow from space.
     *
     * @param ruleId
     * @param version
     */
    Management.prototype.deleteRuleFlow = function (ruleId, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (version) {
                            url = "".concat(this.urlBase, "/rule-flow/").concat(ruleId, "/").concat(version);
                        }
                        else {
                            url = "".concat(this.urlBase, "/rule-flow/").concat(ruleId, "/");
                        }
                        return [4 /*yield*/, axios_1.default.delete(url, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.status];
                }
            });
        });
    };
    /**
     * Returns RuleFlow from space.
     *
     * @param ruleId
     * @param version
     */
    Management.prototype.exportRuleFlow = function (ruleId, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (version) {
                            url = "".concat(this.urlBase, "/rule-flow/export/").concat(ruleId, "/").concat(version);
                        }
                        else {
                            url = "".concat(this.urlBase, "/rule-flow/export/").concat(ruleId, "/");
                        }
                        return [4 /*yield*/, axios_1.default.get(url, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Imports RuleFlow to the space. Input has to be in format [RuleFlow, RuleFlowRule1,...,RuleFlowRuleN]
     *
     * @param ruleFlow
     * @param ruleId
     * @param version
     */
    Management.prototype.importRuleFlow = function (ruleFlow, ruleId, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "";
                        if (!ruleId && !version) {
                            url = "".concat(this.urlBase, "/rule-flow/import");
                        }
                        if (ruleId && !version) {
                            url = "".concat(this.urlBase, "/rule-flow/import/?new-version=").concat(ruleId);
                        }
                        if (ruleId && version) {
                            url = "".concat(this.urlBase, "/rule-flow/import/?overwrite=").concat(ruleId, "&version=").concat(version);
                        }
                        return [4 /*yield*/, axios_1.default.post(url, ruleFlow, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Publish or unpublish rules.
     *
     * @param ruleId
     * @param status
     * @param version
     */
    Management.prototype.changeRuleStatus = function (ruleId, status, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.urlBase, "/rule/status/").concat(ruleId, "/").concat(status, "/").concat(version);
                        return [4 /*yield*/, axios_1.default.put(url, undefined, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Publish or unpublish RuleFlows
     *
     * @param ruleId
     * @param status
     * @param version
     */
    Management.prototype.changeRuleFlowStatus = function (ruleId, status, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.urlBase, "/rule-flow/status/").concat(ruleId, "/").concat(status, "/").concat(version);
                        return [4 /*yield*/, axios_1.default.put(url, undefined, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Returns rule by its tags.
     *
     * @param tags
     */
    Management.prototype.getRulesByTags = function (tags) {
        return __awaiter(this, void 0, void 0, function () {
            var tagsQuery, url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tagsQuery = tags.join(",");
                        url = "".concat(this.urlBase, "/tags/items?tags=").concat(tagsQuery);
                        return [4 /*yield*/, axios_1.default.get(url, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Updates tags on rules.
     *
     * @param ruleId
     * @param tags
     * @param version
     */
    Management.prototype.updateTags = function (ruleId, tags, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (version) {
                            url = "".concat(this.urlBase, "/tags/").concat(ruleId, "/").concat(version);
                        }
                        else {
                            url = "".concat(this.urlBase, "/tags/").concat(ruleId);
                        }
                        return [4 /*yield*/, axios_1.default.patch(url, tags, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Delete tags from rules.
     *
     * @param ruleId
     * @param tags
     * @param version
     */
    Management.prototype.deleteTags = function (ruleId, tags, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, tagsQuery, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tagsQuery = tags.join(',');
                        if (version) {
                            url = "".concat(this.urlBase, "/tags/").concat(ruleId, "/").concat(version, "?tags=").concat(tagsQuery);
                        }
                        else {
                            url = "".concat(this.urlBase, "/tags/").concat(ruleId, "?tags=").concat(tagsQuery);
                        }
                        return [4 /*yield*/, axios_1.default.delete(url, { headers: this.header })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.status];
                }
            });
        });
    };
    return Management;
}());
exports.Management = Management;
